<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('vie.Pag.Das.Bus.ste.SixthStep.text1') }}
    </p>
    <hr />
    <div class="button-add-minus-api">
      <button class="btn btn-secondary custom-shadow-btn" @click="handlePlus()">
        <em class="fa fa-plus"></em>
      </button>
      <button
        v-if="
          (model.station_marks[0] &&
            model.public_key[0] &&
            model.private_key[0]) ||
          model.nKeys > 1
        "
        class="btn btn-secondary custom-shadow-btn"
        @click="handleMinus()"
      >
        <em class="fa fa-minus"></em>
      </button>
    </div>
    <div class="row" v-for="index in model.nKeys" :key="index">
      <div class="col-2">
        <div class="form-group has-label">
          <label v-if="index === 1">{{
            $t('vie.Pag.Das.Bus.ste.SixthStep.text2')
          }}</label>
          <br v-if="index === 1" />
          <el-select
            clearable
            v-bind:collapse-tags="true"
            filterable
            @clear="model.station_marks[index - 1] = null"
            v-bind:class="`select-primary custom-width-select shadow-sm`"
            size="large"
            v-model="model.station_marks[index - 1]"
            :placeholder="`${$t('common_words.select')}... `"
          >
            <el-option
              v-for="(option, index) in marks"
              v-bind:class="`select-primary`"
              v-bind:value="option.id"
              v-bind:label="option.name"
              :key="index"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${
            index === 1 ? $t('vie.Pag.Das.Bus.ste.SixthStep.text3') : ''
          }`"
          v-model="model.public_key[index - 1]"
          placeholder="a3derTHa6..."
          @blur="isEqualToOtherField(index - 1)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="text"
          :label="`${
            index === 1 ? $t('vie.Pag.Das.Bus.ste.SixthStep.text4') : ''
          }`"
          v-model="model.private_key[index - 1]"
          placeholder="a3derTHa6..."
          @blur="isEqualToOtherField(index - 1)"
        ></fg-input>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-1 pr-0">
        <div class="text-left">
          <label style="color: transparent">{{
            index === 1 ? 'Opciones' : ''
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handlePlus()"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
      <div class="col-1 pl-0 pr-0">
        <div class="text-left">
          <label style="color: transparent">{{
            index === 1 ? 'Opciones' : ''
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handleMinus()"
          >
            <em class="fa fa-minus"></em>
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getRepeatsFromArray } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      sameKeys: [],
      marks: [],
      model: {
        nKeys: 1,
        station_marks: [],
        private_key: [],
        public_key: [],
      },
    };
  },
  mixins: [MixinPermissions, mixinMasters],
  methods: {
    isEqualToOtherField(index) {
      if (
        this.model.public_key &&
        this.model.public_key[index] &&
        this.model.public_key[index].length > 0 &&
        this.model.private_key &&
        this.model.private_key[index] &&
        this.model.private_key[index].length > 0
      ) {
        const validate =
          this.model.public_key[index] === this.model.private_key[index];
        this.$set(this.sameKeys, index, validate);
        if (validate) {
          SweetAlert.warning(
            `${i18n.t('sweet_alert.business.private_public_keys')} ${
              index + 1
            } ${i18n.t('sweet_alert.business.check_same_information')}.`
          );
        }

        return validate;
      }
      return false;
    },

    validateRepeated() {
      const repeatMarks = getRepeatsFromArray(this.model.station_marks);
      const repeatPublicKey = getRepeatsFromArray(this.model.public_key);
      const repeatPrivateKey = getRepeatsFromArray(this.model.private_key);

      let msg = `${i18n.t('message.business.msg_part1')} $replace$; ${i18n.t(
        'message.business.msg_part2'
      )} .`;

      if (repeatMarks.length > 0) {
        SweetAlert.warning(
          msg.replace('$replace$', i18n.t('message.replace.selected_markings'))
        );
      } else if (repeatPublicKey.length > 0) {
        SweetAlert.warning(
          msg.replace(
            '$replace$',
            i18n.t('message.replace.entered_public_keys')
          )
        );
      } else if (repeatPrivateKey.length > 0) {
        SweetAlert.warning(
          msg.replace(
            '$replace$',
            i18n.t('message.replace.entered_private_keys')
          )
        );
      }

      return [repeatMarks, repeatPublicKey, repeatPrivateKey];
    },

    validate() {
      this.model.station_marks = this.model.station_marks;
      this.model.private_key = this.model.private_key;
      this.model.public_key = this.model.public_key;

      return this.$validator
        .validateAll()
        .then((res) => {
          if (!res) return res;

          this.$emit('on-validated', res, this.model);
          let others = [];
          this.model.station_marks.forEach((element) => {
            this.marks.forEach((item) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          this.$emit('fillBusinessForm', 'sixthStep', {
            station_mark: others,
          });
          return res;
        })
        .then(() => {
          console.log('this.model', this.model);
          if (this.model.station_marks.length > 0) {
            for (
              let index = 0;
              index < this.model.station_marks.length;
              index++
            ) {
              const markId = this.model.station_marks[index];
              if (markId) {
                const markName = this.marks.find(
                  (mark) => mark.id === markId
                ).name;
                if (
                  !this.model.public_key[index] ||
                  this.model.public_key[index].length === 0
                ) {
                  SweetAlert.warning(
                    `${i18n.t(
                      'vie.Pag.Das.Bus.ste.SixthStep.textpart1'
                    )} ${markName} ${i18n.t(
                      'vie.Pag.Das.Bus.ste.SixthStep.textpart2'
                    )}${index + 1}`
                  );

                  return false;
                }

                if (
                  !this.model.private_key[index] ||
                  this.model.private_key[index].length === 0
                ) {
                  SweetAlert.warning(
                    `${i18n.t(
                      'vie.Pag.Das.Bus.ste.SixthStep.textpart3'
                    )} ${markName} ${i18n.t(
                      'vie.Pag.Das.Bus.ste.SixthStep.textpart4'
                    )} ${index + 1}`
                  );

                  return false;
                }
              }
            }

            const repeats = this.validateRepeated();
            if (
              repeats[0].length > 0 ||
              repeats[1].length > 0 ||
              repeats[2].length > 0
            ) {
              return false;
            } else {
              if (this.sameKeys.includes(true)) {
                this.model.private_key.forEach((_, index) =>
                  this.isEqualToOtherField(index)
                );
                return false;
              } else return true;
            }
          } else return true;
        });
    },

    handleMinus() {
      const amounToMinus = this.model.nKeys;
      if (this.model.nKeys > 1) {
        this.model.nKeys--;
        this.model.station_marks = this.model.station_marks.splice(
          0,
          this.model.nKeys
        );
        this.model.private_key = this.model.private_key.splice(
          0,
          this.model.nKeys
        );
        this.model.public_key = this.model.public_key.splice(
          0,
          this.model.nKeys
        );
      }

      if (amounToMinus === 1) {
        this.$set(this.model.station_marks, 0, null);
        this.$set(this.model.public_key, 0, '');
        this.$set(this.model.private_key, 0, '');
      }
    },

    handlePlus() {
      this.model.nKeys++;
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('devices/stationmarks/select')])
        .then((response) => {
          const [responseMark] = response;
          this.marks = responseMark.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));

      this.model.station_marks = editForm.business_weather_apis.map(
        (mark) => mark.station_mark_id
      );
      this.model.public_key = editForm.business_weather_apis.map(
        (mark) => mark.public_key
      );
      this.model.private_key = editForm.business_weather_apis.map(
        (mark) => mark.private_key
      );

      this.model.nKeys =
        editForm.business_weather_apis.length > 0
          ? editForm.business_weather_apis.length
          : 1;
    }
  },
};
</script>
<style>
.button-add-minus-api {
  position: fixed;
  margin-top: 29px;
  z-index: 9;
  display: flex;
  justify-content: space-between;
  right: 10%;
  flex-direction: row;
  width: 115px;
}
</style>
